import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SavedFilterType} from "../save-filters.dto";
import {ISavedFiltersState} from "./saved-filters.reducers";
import {savedFiltersFeatureKey} from "./saved-filtes.config";

export const state = createFeatureSelector<ISavedFiltersState>(savedFiltersFeatureKey);

export const filtersByType = (type: SavedFilterType)=> createSelector(state, state => state.filters.filter(x=>x.type === type));
export const selectFilter = (filterId:number) => createSelector(state, state => state.filters.find(x=>x.id === filterId));
export const selectedFilter = createSelector(state, state => state.selectedSavedFilter);
